import {
  MediaPlayer,
  MediaProvider,
  Track,
  type MediaPlayerInstance,
} from '@vidstack/react'
import {
  DefaultVideoLayout,
  defaultLayoutIcons,
} from '@vidstack/react/player/layouts/default'
import { useRef } from 'react'
import type { TextTrack } from '../lib/types'

interface Props {
  src: string
  poster?: string
  title?: string
  thumbnails?: string
  tracks?: TextTrack[]
}

export default function PlayerShell({ src, poster, title, thumbnails, tracks }: Props) {
  const playerRef = useRef<MediaPlayerInstance>(null)

  return (
    <div className="player-shell overflow-hidden rounded-xl bg-black shadow-2xl ring-1 ring-white/5">
      <MediaPlayer
        ref={playerRef}
        title={title ?? 'UB Video'}
        src={src}
        poster={poster}
        crossOrigin
        playsInline
        preload="metadata"
        aspectRatio="16/9"
      >
        <MediaProvider>
          {tracks?.map((t) => (
            <Track
              key={t.src}
              src={t.src}
              kind={t.kind}
              label={t.label}
              lang={t.language}
              default={t.default}
            />
          ))}
        </MediaProvider>
        <DefaultVideoLayout icons={defaultLayoutIcons} thumbnails={thumbnails} />
      </MediaPlayer>
    </div>
  )
}
